<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{$t('Quotation-Form')}}</v-toolbar-title>
              <v-spacer></v-spacer>

              <!-- <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu> -->
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 pt-2 md2>
                        <v-select
                          :label="this.$t('Search')"
                          items-value="value"
                          item-text="text"
                          :items="itemstip"
                          v-model="Kotasyon.Tip"
                        ></v-select>
                      </v-flex>

                      <v-flex xs12 v-if="Kotasyon.Tip == 1" sm6 pt-2 md2>
                        <pnrbul v-model="Kotasyon.Id"></pnrbul>
                      </v-flex>

                      <v-flex xs12 pt-2 v-if="Kotasyon.Tip == 2" sm6 md2>
                      <takipno v-model="Kotasyon.Id" hide-details> </takipno>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <v-select
                          hide-details
                          :items="doviztipi"
                          v-model="Kotasyon.ParaBirimi"
                          :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                          item-text="Title"
                          item-value="DovizKod"
                          :label="$t('Currency-Unit')"
                        ></v-select>
                      </v-flex>
                   
                      <v-flex xs12  pl-2 sm6 md2>
                        <v-checkbox
                          small
                          v-model="Kotasyon.FaturaTurariKdvHaric"
                          :label="$t('Calculate-Excluding-VAT')"
                          color="green"
                        >
                        </v-checkbox>
                      </v-flex>
                      <v-flex xs12  pl-2 sm6 md2>
                        <v-checkbox
                          small
                          v-model="Toplam0Gosterme"
                          :label="$t('Dont-show-items-that-add-up-to-0')"
                          color="green"
                        >
                        </v-checkbox>
                      </v-flex>
                      <v-flex xs12  pl-2 sm6 md2>
                        <v-checkbox
                          small
                          v-model="resarvationNoteView"
                          :label="this.$t('Reservation-Notes')"
                          color="green"
                        >
                        </v-checkbox>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn
                              color="info"
                              @click="getList()"
                              fab
                              small
                              dark
                            >
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout pt-3 align-center>
                              <v-progress-circular
                                indeterminate
                                :width="4"
                                color="blue"
                              ></v-progress-circular>
                            </v-layout>
                          </div>
   
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 pt-2 sm12 md12>
                  <v-layout row wrap>

                    <v-flex v-if="faturagoster == true" xs10 pa-2 sm10>
                      <v-card flat>
                        <v-layout justify-end row wrap>
                          <v-flex xs12 pa-3 sm12>
                            <div id="printJS-form">
                              <table
                                name="table"
                                id="table"
                                style="width: 100%; border: 1px solid black"
                              >
                                <tbody style="width: 100%; margin: 10px">
                                  <tr style="width: 100%">
                                    <td style="text-align: center" colspan="8">
                                      <br />
                                      <p>
                                        <strong
                                          ><span style="color: #3366ff"
                                            > {{ $t('Quotation-Form') }} </span
                                          ></strong
                                        >
                                      </p>
                                    </td>
                                    <td style="text-align: right">
                                      {{ getDateNow() | dateformat }}&nbsp;
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="text-align: center" colspan="9">
                                      <p></p>
                                    </td>
                                  </tr>

                                  <tr>
                                    <td
                                      style="width: 110px; vertical-align: top"
                                    >
                                      Pnr No
                                    </td>
                                    <td style="width: 8px; vertical-align: top">
                                      :
                                    </td>
                                    <td
                                      style="width: 243px; vertical-align: top"
                                    >
                                      {{ kotasyonData.PNR_No }}
                                    </td>
                                    <td style="width: 0px">&nbsp;</td>
                                    <td style="width: 0px">&nbsp;</td>
                                    <td
                                      style="width: 153px; vertical-align: top"
                                    >
                                      {{ $t('Registration-Date') }}
                                    </td>
                                    <td style="width: 8px; vertical-align: top">
                                      :
                                    </td>
                                    <td
                                      style="width: 123px; vertical-align: top"
                                    >
                                      {{
                                        kotasyonData.KayitTarihi | dateformat
                                      }}
                                    </td>
                                    <td style="width: 1px">&nbsp;</td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="width: 110px; vertical-align: top"
                                    >
                                       {{ $t('Tracking-No') }} 
                                    </td>
                                    <td style="width: 8px; vertical-align: top">
                                      :
                                    </td>
                                    <td
                                      style="width: 243px; vertical-align: top"
                                    >
                                      {{ kotasyonData.TakipNo }}
                                    </td>
                                    <td style="width: 0px">&nbsp;</td>
                                    <td style="width: 0px">&nbsp;</td>
                                    <td
                                      style="width: 153px; vertical-align: top"
                                    >
                                      {{ $t('Position-No') }}
                                    </td>
                                    <td style="width: 8px; vertical-align: top">
                                      :
                                    </td>
                                    <td
                                      style="width: 123px; vertical-align: top"
                                    >
                                      {{ kotasyonData.PozisyonNo }}
                                    </td>
                                    <td style="width: 1px">&nbsp;</td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="width: 110px; vertical-align: top"
                                    >
                                       {{ $t('Counter-Res-Code') }} 
                                    </td>
                                    <td style="width: 8px; vertical-align: top">
                                      :
                                    </td>
                                    <td
                                      style="width: 243px; vertical-align: top"
                                    >
                                      {{ kotasyonData.KarsiRezKod }}
                                    </td>
                                    <td style="width: 0px">&nbsp;</td>
                                    <td style="width: 0px">&nbsp;</td>
                                    <td
                                      style="width: 153px; vertical-align: top"
                                    >
                                      {{ $t('Booker') }}
                                    </td>
                                    <td style="width: 8px; vertical-align: top">
                                      :
                                    </td>
                                    <td
                                      style="width: 123px; vertical-align: top"
                                    >
                                      {{ kotasyonData.RezYapan }}
                                    </td>
                                    <td style="width: 1px">&nbsp;</td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="width: 110px; vertical-align: top"
                                    >
                                      {{$t('Tour-Code')}}
                                    </td>
                                    <td style="width: 8px; vertical-align: top">
                                      :
                                    </td>
                                    <td
                                      style="width: 243px; vertical-align: top"
                                    >
                                      {{ kotasyonData.TurKodu }}
                                    </td>
                                    <td style="width: 0px">&nbsp;</td>
                                    <td style="width: 0px">&nbsp;</td>
                                    <td
                                      style="width: 153px; vertical-align: top"
                                    >
                                      {{$t('Person-Offering-Booking')}}
                                    </td>
                                    <td style="width: 8px; vertical-align: top">
                                      :
                                    </td>
                                    <td
                                      style="width: 123px; vertical-align: top"
                                    >
                                      {{ kotasyonData.RezVeren }}
                                    </td>
                                    <td style="width: 1px">&nbsp;</td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="width: 110px; vertical-align: top"
                                    >
                                      {{ $t("Currentcode_label") }}
                                    </td>
                                    <td style="width: 8px; vertical-align: top">
                                      :
                                    </td>
                                    <td colspan="3" style="vertical-align: top">
                                      {{ kotasyonData.Musteri.kod }}-{{
                                        kotasyonData.Musteri.isim
                                      }}
                                    </td>

                                    <td
                                      style="width: 153px; vertical-align: top"
                                    >
                                      {{$t('Reference')}}
                                    </td>
                                    <td style="width: 8px; vertical-align: top">
                                      :
                                    </td>
                                    <td
                                      style="width: 123px; vertical-align: top"
                                    >
                                      {{ kotasyonData.Referans }}
                                    </td>
                                    <td style="width: 1px">&nbsp;</td>
                                  </tr>
                                  <tr>
                                    <td style="width: 153px; vertical-align: top">

                                    </td>
                                    <td style="width: 8px; vertical-align: top">
                                      
                                    </td>
                                    <td colspan="3" style="vertical-align: top">

                                    </td>
                                    <td style="width: 153px; vertical-align: top">
                                      {{ $t("Expense-Center") }}
                                    </td>
                                    <td style="width: 8px; vertical-align: top">
                                      :
                                    </td>
                                    <td style="width: 153px; vertical-align: top">
                                      {{kotasyonData.MasrafMerkezi.Kod }} - {{kotasyonData.MasrafMerkezi.isim }}  
                                    </td>
                                    <td style="width: 1px">&nbsp;</td>
                                  </tr>
                                </tbody>
                              </table>
                              <p>&nbsp;</p>
                              <table style="width: 100%" border="1">
                                <tbody>
                                  <tr>
                                    <td style="text-align: center" colspan="10">
                                      <span style="color: #3366ff"
                                        ><br /><strong
                                          > {{ $t('SALES-PRICES') }} </strong
                                        ></span
                                      >
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="text-align: center">
                                      <strong>{{ $t('Description') }}</strong>
                                    </td>
                                    <td style="width: 15%; text-align: center">
                                      <strong>Giriş-&Ccedil;ıkış Tarihi</strong>
                                    </td>
                                    <td style="width: 5%; text-align: center">
                                      <strong>Pax</strong>
                                    </td>
                                    <td style="width: 5%; text-align: center">
                                      <strong> {{ $t('night') }} </strong>
                                    </td>
                                    <td style="width: 5%; text-align: center">
                                      <strong>{{ $t('Room') }}</strong>
                                    </td>
                                    <td style="width: 7%; text-align: center">
                                      <strong>{{ $t('Unit-Price') }}</strong>
                                    </td>
                                    <td style="width: 7%; text-align: center">
                                      <strong>{{$t('Currency-Unit')}}</strong>
                                    </td>
                                    <td style="width: 7%; text-align: center">
                                      <strong>{{ $t('Exchange-Rate-v2') }}</strong>
                                    </td>
                                    <td style="width: 7%; text-align: center">
                                      <strong> {{ $t('Amount') }} </strong>
                                    </td>
                                    <td style="width: 7%; text-align: center">
                                      <strong>{{ getDovizAdi() }} {{ $t('Amount') }}</strong>
                                    </td>
                                  </tr>
                                  <tr
                                    v-for="items in kotasyonData.Satis"
                                    :key="items.id"
                                  >
                                    <td style="text-align: left">
                                      {{ items.Aciklama }}
                                    </td>
                                    <td style="text-align: center">
                                      {{ items.Donem1 | dateformat }}-{{
                                        items.Donem2 | dateformat
                                      }}
                                    </td>
                                    <td style="text-align: center">
                                      {{ items.Pax }}
                                    </td>
                                    <td style="text-align: center">
                                      {{ items.Gece }}
                                    </td>
                                    <td style="text-align: center">
                                      {{items.Oda}}
                                    </td>
                                    <td style="text-align: right">
                                      {{ items.BirimFiyat | moneyformat }}
                                    </td>
                                    <td style="text-align: center">
                                      {{ items.ParaBirimi }}
                                    </td>
                                    <td style="text-align: right">
                                      {{ items.Kur | currencyformat }}
                                    </td>
                                    <td style="text-align: right">
                                      {{ items.DovizTutar | moneyformat }}
                                    </td>
                                    <td style="text-align: right" v-if="UlkeID==1">
                                    {{ items.Tutar | moneyformat }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="width: 10%; text-align: right"
                                      colspan="9"
                                    >
                                      <strong>  {{ $t('Sales-Total') }} :&nbsp;</strong>
                                    </td>
                                    <td style="width: 6%; text-align: right">
                                      {{
                                        kotasyonData.Toplamlar.Satis
                                          | moneyformat
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <p>&nbsp;</p>
                              <table style="width: 100%" border="1">
                                <tbody>
                                  <tr>
                                    <td style="text-align: center" colspan="10">
                                      <span style="color: #3366ff"
                                        ><br /><strong>{{ $t('EXPENSES') }}</strong></span
                                      >
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="text-align: center">
                                      <strong>{{ $t('Description') }}</strong>
                                    </td>
                                    <td style="width: 15%; text-align: center">
                                      <strong>Giriş-Çıkış Tarihi</strong>
                                    </td>
                                    <td style="width: 5%; text-align: center">
                                      <strong>Pax</strong>
                                    </td>
                                    <td style="width: 5%; text-align: center">
                                      <strong> {{ $t('Night') }} </strong>
                                    </td>
                                    <td style="width: 5%; text-align: center">
                                      <strong> {{ $t('Room') }}</strong>
                                    </td>
                                    <td style="width: 7%; text-align: center">
                                      <strong>{{$t('Unit-Price')}} </strong>
                                    </td>
                                    <td style="width: 7%; text-align: center">
                                      <strong>{{$t('Currency-Unit')}}</strong>
                                    </td>
                                    <td style="width: 7%; text-align: center">
                                      <strong>{{ $t('Exchange-Rate-v2') }}</strong>
                                    </td>
                                    <td style="width: 7%; text-align: center">
                                      <strong>{{ $t('Amount') }}</strong>
                                    </td>
                                    <td style="width: 7%; text-align: center">
                                      <strong>{{ getDovizAdi() }}  {{ $t('Amount') }} </strong>
                                    </td>
                                  </tr>
                                  <tr
                                    v-for="items1 in kotasyonData.Alis"
                                    :key="items1.id" 
                                  >
                                    <td style="text-align: left">
                                      {{ items1.Aciklama }}
                                    </td>
                                    <td style="text-align: center">
                                      {{ items1.Donem1 | dateformat }}-{{
                                        items1.Donem2 | dateformat
                                      }}
                                    </td>
                                    <td style="text-align: center">
                                      {{ items1.Pax }}
                                    </td>
                                    <td style="text-align: center">
                                      {{ items1.Gece }}
                                    </td>
                                    <td style="text-align: center">
                                      {{ items1.Oda }}
                                    </td>
                                    <td style="text-align: right">
                                      {{ items1.BirimFiyat | moneyformat }}
                                    </td>
                                    <td style="text-align: center">
                                      {{ items1.ParaBirimi }}
                                    </td>
                                    <td style="text-align: right">
                                      {{ items1.Kur | currencyformat }}
                                    </td>
                                    <td style="text-align: right">
                                      {{ items1.DovizTutar | moneyformat }}
                                    </td>
                                    <td style="text-align: right"  v-if="UlkeID==1">
                                      {{ items1.Tutar | moneyformat }}
                                     
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="width: 10%; text-align: right"
                                      colspan="9"
                                    >
                                      <strong> Maliyet Toplam:&nbsp; </strong>
                                    </td>
                                    <td style="width: 6%; text-align: right">
                                      {{
                                        kotasyonData.Toplamlar.Alis
                                          | moneyformat
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <p>&nbsp;</p>

                              <table style="width: 100%" border="1" v-if="!Toplam0Gosterme || (Toplam0Gosterme && kotasyonData.Toplamlar.Komisyon>0)">
                                <tbody>
                                  <tr>
                                    <td style="text-align: center" colspan="5">
                                      <span style="color: #3366ff"
                                        ><br /><strong
                                          >{{ $t('COMMISSIONS') }}</strong
                                        ></span
                                      >
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="text-align: center">
                                      <strong>{{ $t('Description') }}</strong>
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      <strong>{{$t('Currency-Unit')}}</strong>
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      <strong> {{ $t('Exchange-Rate-v2') }} </strong>
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      <strong> {{ $t('Amount') }} </strong>
                                    </td>
                                    <td style="width: 8%; text-align: center" v-if="UlkeID==1">
                                      <strong>{{ getDovizAdi() }} {{ $t('Amount') }}</strong>
                                    </td>
                                  </tr>
                                  <tr
                                    v-for="items2 in kotasyonData.Komisyon"
                                    :key="items2.id"
                                  >
                                    <td style="">{{ items2.Aciklama }}</td>
                                    <td style="width: 8%; text-align: center">
                                      {{ items2.ParaBirimi }}
                                    </td>
                                    <td style="width: 8%; text-align: right">
                                      {{ items2.Kur | currencyformat }}
                                    </td>
                                    <td style="width: 8%; text-align: right">
                                      {{ items2.DovizTutar | moneyformat }}
                                    </td>
                                    <td style="width: 8%; text-align: right" v-if="UlkeID==1">
                                    {{ items2.Tutar | moneyformat }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="width: 10%; text-align: right"
                                      colspan="4"
                                    >
                                      <strong> Komisyon Toplam:&nbsp;</strong>
                                    </td>
                                    <td style="width: 6%; text-align: right">
                                      {{
                                        kotasyonData.Toplamlar.Komisyon
                                          | moneyformat
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                              <p>&nbsp;</p>
                              <table style="width: 100%" border="1" v-if="!Toplam0Gosterme || (Toplam0Gosterme &&  kotasyonData.Toplamlar.SaticiOdemesi>0)">
                                <tbody>
                                  <tr>
                                    <td style="text-align: center" colspan="7">
                                      <span style="color: #3366ff"
                                        ><br /><strong
                                          >SATICILARA YAPILAN
                                          &Ouml;DEMELER</strong
                                        ></span
                                      >
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="text-align: center">
                                      <strong
                                        >{{ $t('The-Company') }} / {{ $t('Accound-Code')}} / Kredi Kart No</strong
                                      >
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      <strong>{{$t('Date')}}</strong>
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      <strong>{{ $t('Type-v2') }} </strong>
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      <strong>{{$t('Currency-Unit')}}</strong>
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      <strong> {{ $t('Exchange-Rate-v2') }} </strong>
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      <strong>{{  $t('Amount') }} </strong>
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      <strong>{{ getDovizAdi() }} {{ $t('Amount') }}</strong>
                                    </td>
                                  </tr>
                                  <tr
                                    v-for="items3 in kotasyonData.SaticiOdemeleri"
                                    :key="items3.id"
                                  >
                                    <td>
                                      {{ items3.SaticiKod }}/{{
                                        items3.CariUnvan
                                      }}/{{ items3.KartNo }}
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      {{ items3.Tarih | dateformat }}
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      {{ items3.EvrakTipi }}
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      {{ items3.ParaBirimi }}
                                    </td>
                                    <td style="width: 8%; text-align: right">
                                      {{ items3.Kur | currencyformat }}
                                    </td>
                                    <td style="width: 8%; text-align: right">
                                      {{ items3.DovizTutar | moneyformat }}
                                    </td>
                                    <td style="width: 8%; text-align: right" v-if="UlkeID==1">
                                     {{ items3.Tutar | moneyformat }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="width: 10%; text-align: right"
                                      colspan="6"
                                    >
                                      <strong>  {{ $t('Total-Payment') }} :&nbsp;</strong>
                                    </td>
                                    <td
                                      style="
                                        width: 6%;
                                        font-color: red;
                                        text-align: right;
                                      "
                                    >
                                      {{
                                        kotasyonData.Toplamlar.SaticiOdemesi
                                          | moneyformat
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                              <p>&nbsp;</p>
                              <table style="width: 100%" border="1" v-if="!Toplam0Gosterme || (Toplam0Gosterme &&  kotasyonData.Toplamlar.Tahsilat>0)">
                                <tbody>
                                  <tr>
                                    <td style="text-align: center" colspan="7">
                                      <span style="color: #3366ff"
                                        ><strong
                                          ><br /> {{$t('COLLECTION')}}</strong
                                        ></span
                                      >
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="text-align: center">
                                      <strong>{{ $t('The-Company') }} </strong>
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      <strong>{{$t('Date')}}</strong>
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      <strong> {{ $t('Type-v2') }} </strong>
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      <strong>{{$t('Currency-Unit')}}</strong>
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      <strong> {{ $t('Exchange-Rate-v2') }} </strong>
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      <strong> {{ $t('Amount') }} </strong>
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      <strong>{{ getDovizAdi() }} {{ $t('Amount') }}</strong>
                                    </td>
                                  </tr>
                                  <tr
                                    v-for="items4 in kotasyonData.Tahsilatlar"
                                    :key="items4.id"
                                  >
                                    <td style="">{{ items4.CariKod }}</td>
                                    <td style="width: 8%; text-align: center">
                                      {{ items4.Tarih | dateformat }}
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      {{ items4.EvrakTipi }}
                                    </td>
                                    <td style="width: 8%; text-align: center">
                                      {{ items4.ParaBirimi }}
                                    </td>
                                    <td style="width: 8%; text-align: right">
                                      {{ items4.Kur | currencyformat }}
                                    </td>
                                    <td style="width: 8%; text-align: right">
                                      {{ items4.DovizTutar | moneyformat }}
                                    </td>
                                    <td style="width: 8%; text-align: right"  v-if="UlkeID==1"> 
                                     {{ items4.Tutar | moneyformat }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="width: 10%; text-align: right"
                                      colspan="6"
                                    >
                                      <strong> Toplam Tahsilat:&nbsp; </strong>
                                    </td>
                                    <td style="width: 6%; text-align: right">
                                      {{
                                        kotasyonData.Toplamlar.Tahsilat
                                          | moneyformat
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                              <v-divider></v-divider>

                              <p>&nbsp;</p>
                              <table style="width: 100%">
                                <tbody>
                                  <tr>
                                    <td style="width: 37%">&nbsp;</td>
                                    <td style="width: 10%">&nbsp;</td>
                                    <td
                                      style="
                                        width: 29.9635%;
                                        text-align: center;
                                      "
                                    >
                                      &nbsp;
                                    </td>
                                    <td
                                      style="
                                        width: 11.0365%;
                                        text-align: center;
                                        border: 1px solid black;
                                      "
                                    >
                                      <strong> {{$t('Currency-Unit')}}</strong>
                                    </td>
                                    <td
                                      style="
                                        width: 12%;
                                        text-align: center;
                                        border: 1px solid black;
                                      "
                                    >
                                      <strong>  {{ $t('Total') }} </strong>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="
                                        width: 37%;
                                        border: 1px solid black;
                                        text-align: center;
                                      "
                                    >
                                      <strong
                                        > {{ $t('Total-Profitability-Ratio') }} : %
                                        {{
                                          kotasyonData.Toplamlar
                                            .TahminiKarlilikOrani | moneyformat
                                        }}</strong
                                      >
                                    </td>
                                    <td style="width: 10%">&nbsp;</td>
                                    <td
                                      style="
                                        width: 29.9635%;
                                        border: 1px solid black;
                                      "
                                    >
                                      <strong>{{ $t('Total-Sales') }}:</strong>
                                    </td>
                                    <td
                                      style="
                                        text-align: center;
                                        width: 11.0365%;
                                        border: 1px solid black;
                                      "
                                      rowspan="6"
                                    >
                                      {{ getDovizAdi() }}
                                    </td>
                                    <td
                                      style="
                                        width: 12%;
                                        text-align: right;
                                        border: 1px solid black;
                                      "
                                    >
                                      {{
                                        kotasyonData.Toplamlar.Satis
                                          | moneyformat
                                      }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="width: 37%; text-align: center">
                                      <strong>&nbsp;</strong>
                                    </td>
                                    <td style="width: 10%">&nbsp;</td>
                                    <td
                                      style="
                                        width: 29.9635%;
                                        border: 1px solid black;
                                      "
                                    >
                                      <strong>Toplam İskonto:</strong>
                                    </td>
                                    <td
                                      style="
                                        width: 12%;
                                        text-align: right;
                                        border: 1px solid black;
                                      "
                                    >
                                      {{
                                        kotasyonData.Toplamlar.Iskonto
                                          | moneyformat
                                      }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="width: 37%; text-align: center">
                                      <strong></strong>
                                    </td>
                                    <td style="width: 10%"></td>
                                    <td
                                      style="
                                        width: 29.9635%;
                                        border: 1px solid black;
                                      "
                                    >
                                      <strong> {{ $t('Total-Expenses') }} :</strong>
                                    </td>
                                    <td
                                      style="
                                        width: 12%;
                                        text-align: right;
                                        border: 1px solid black;
                                      "
                                    >
                                      {{
                                        kotasyonData.Toplamlar.Alis
                                          | moneyformat
                                      }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="width: 37%; text-align: center">
                                      <strong>&nbsp;</strong>
                                    </td>
                                    <td style="width: 10%">&nbsp;</td>
                                    <td
                                      style="
                                        width: 29.9635%;
                                        border: 1px solid black;
                                      "
                                    >
                                      <strong>Toplam Komisyon:</strong>
                                    </td>
                                    <td
                                      style="
                                        width: 12%;
                                        text-align: right;
                                        border: 1px solid black;
                                      "
                                    >
                                      {{
                                        kotasyonData.Toplamlar.Komisyon
                                          | moneyformat
                                      }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="
                                        width: 37%;
                                        text-align: center;
                                        border: 1px solid black;
                                      "
                                    >
                                      <strong
                                        >{{this.$t('Profitability')}}
                                        Oranı: %
                                        {{
                                          kotasyonData.Toplamlar
                                            .GerceklesenKarlilikOrani
                                            | moneyformat
                                        }}</strong
                                      >
                                    </td>
                                    <td style="width: 10%">&nbsp;</td>
                                    <td
                                      style="
                                        width: 29.9635%;
                                        border: 1px solid black;
                                      "
                                    >
                                      <strong>{{this.$t('Agency-Commission-Amount')}}:</strong>
                                    </td>
                                    <td
                                      style="
                                        width: 12%;
                                        text-align: right;
                                        border: 1px solid black;
                                      "
                                    >
                                      {{
                                        kotasyonData.Toplamlar.AcenteKomisyon
                                          | moneyformat
                                      }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="width: 37%">&nbsp;</td>
                                    <td style="width: 10%">&nbsp;</td>
                                    <td
                                      style="
                                        width: 29.9635%;
                                        border: 1px solid black;
                                      "
                                    >
                                      <strong>{{$t('Profit')}}:</strong>
                                    </td>
                                    <td
                                      style="
                                        width: 12%;
                                        text-align: right;
                                        border: 1px solid black;
                                      "
                                    >
                                      {{
                                        kotasyonData.Toplamlar.Kar | moneyformat
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              
                              <p>&nbsp;</p>
                              <p v-if="resarvationNoteView"> {{  kotasyonData.Notlar }} </p>
                              <p v-if="resarvationNoteView">&nbsp;</p>

                              <table style="width: 100%">
                                <tbody>
                                  <tr>
                                    <td style="text-align: center" colspan="9">
                                      <span v-if="KdvHaric" style="color: #3366ff"
                                        ><strong
                                          >  {{ $t('INVOICE-INFORMATION-WITHOUT-VAT') }} </strong
                                        ></span
                                      >

                                       <span v-if="!KdvHaric" style="color: #3366ff"
                                        ><strong
                                          >  KDV'Lİ FATURA BİLGİLERİ  </strong
                                        ></span
                                      >

                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="
                                        text-align: center;
                                        border-bottom: 1px solid black !important;
                                        width: 10%;
                                      "
                                    >
                                      <strong>{{ $t('Invoice-Type') }}</strong>
                                    </td>
                                    <td
                                      style="
                                        text-align: center;
                                        border-bottom: 1px solid black !important;
                                        width: 5%;
                                      "
                                    >
                                      <strong>{{$t('Invoice-No')}}</strong>
                                    </td>
                                    <td
                                      style="
                                        text-align: center;
                                        border-bottom: 1px solid black !important;
                                        width: 10%;
                                      "
                                    >
                                      <strong>{{$t('Invoice-Date')}}</strong>
                                    </td>
                                    <td
                                      style="
                                        text-align: center;
                                        border-bottom: 1px solid black !important;
                                      "
                                    >
                                      <strong>Cari &Uuml;nvan</strong>
                                    </td>
                                    <td
                                      style="
                                        text-align: right;
                                        border-bottom: 1px solid black !important;
                                        width: 8%;
                                      "
                                    >
                                      <strong> {{ $t('Invoice-Received') }} </strong>
                                    </td>
                                    <td
                                      style="
                                        text-align: right;
                                        border-bottom: 1px solid black !important;
                                        width: 8%;
                                      "
                                    >
                                      <strong> Satış Fat.</strong>
                                    </td>
                                    <td
                                      style="
                                        text-align: right;
                                        border-bottom: 1px solid black !important;
                                        width: 8%;
                                      "
                                    >
                                      <strong> Kom. Fat.</strong>
                                    </td>
                                    <td
                                      style="
                                        text-align: right;
                                        border-bottom: 1px solid black !important;
                                        width: 8%;
                                      "
                                    >
                                      <strong> {{ $t('Refund-Invoice') }}</strong>
                                    </td>
                                    <td
                                      style="
                                        text-align: right;
                                        border-bottom: 1px solid black !important;
                                        width: 8%;
                                      "
                                    >
                                      <strong> Satış Ia. Fat.</strong>
                                    </td>
                                  </tr>
                                  <tr
                                    v-for="items5 in kotasyonData.Faturalar"
                                    :key="items5.id"
                                  >
                                    <td style="width: 10%; vertical-align: top">
                                      {{ items5.TipAciklama }}
                                    </td>
                                    <td
                                      style="
                                        width: 5%;
                                        text-align: center;
                                        vertical-align: top;
                                      "
                                    >
                                      {{ items5.No }}
                                    </td>
                                    <td
                                      style="
                                        text-align: center;
                                        width: 10%;
                                        vertical-align: top;
                                      "
                                    >
                                      {{ items5.Tarih | dateformat }}
                                    </td>
                                    <td style="vertical-align: top">
                                      {{ items5.CariUnvan }}
                                    </td>
                                    <td
                                      style="
                                        width: 8%;
                                        text-align: right;
                                        vertical-align: top;
                                      "
                                    >
                                      {{ items5 | gelenfat }}
                                    </td>
                                    <td
                                      style="
                                        width: 8%;
                                        text-align: right;
                                        vertical-align: top;
                                      "
                                    >
                                      {{ items5 | satisfat }}
                                      <p class="align-center">({{items5.KDVTutar}})</p>
                                    </td>
                                    <td
                                      style="
                                        width: 8%;
                                        text-align: right;
                                        vertical-align: top;
                                      "
                                    >
                                      {{ items5 | komfat }}
                                    </td>
                                    <td
                                      style="
                                        width: 8%;
                                        text-align: right;
                                        vertical-align: top;
                                      "
                                    >
                                      {{ items5 | iafat }}
                                    </td>
                                    <td
                                      style="
                                        width: 8%;
                                        text-align: right;
                                        vertical-align: top;
                                      "
                                    >
                                      {{ items5 | satisiafat }}
                                      
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <p>&nbsp;</p>

                              <v-divider></v-divider>
                              <table style="width: 100%">
                                <tbody>
                                  <tr>
                                    <td style="width: 20.7518%">&nbsp;</td>
                                    <td
                                      style="
                                        text-align: right;
                                        width: 10%;
                                        border-bottom: 1px solid black !important;
                                      "
                                    >
                                      <strong> {{ $t('Invoice-Received') }} </strong>
                                    </td>
                                    <td
                                      style="
                                        text-align: right;
                                        border-bottom: 1px solid black !important;
                                        width: 10%;
                                      "
                                    >
                                      <strong>Satış Fat.</strong>
                                    </td>
                                    <td
                                      style="
                                        text-align: right;
                                        border-bottom: 1px solid black !important;
                                        width: 10%;
                                      "
                                    >
                                      <strong>Kom. Fat.</strong>
                                    </td>
                                    <td
                                      style="
                                        text-align: right;
                                        border-bottom: 1px solid black !important;
                                        width: 10%;
                                      "
                                    >
                                      <strong> {{ $t('Refund-Invoice') }} </strong>
                                    </td>
                                    <td
                                      style="
                                        text-align: right;
                                        width: 10%;
                                        border-bottom: 1px solid black !important;
                                      "
                                    >
                                      <strong>Satış Ia. Fat.</strong>
                                    </td>
                                    <td
                                      style="
                                        text-align: right;
                                        width: 10%;
                                        border-bottom: 1px solid black !important;
                                      "
                                    >
                                      <strong>{{$t('Profit')}}</strong>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="
                                        text-align: right;
                                        vertical-align: top;
                                      "
                                    >
                                      <strong> {{ $t('Total-Invoices') }}  ({{Kur}}) :</strong>
                                    </td>
                                    <td
                                      style="
                                        width: 10%;
                                        text-align: right;
                                        vertical-align: top;
                                      "
                                    >
                                      {{
                                        kotasyonData.FaturaToplam.Gelen
                                          | moneyformat
                                      }}
                                    </td>
                                    <td
                                      style="
                                        width: 10%;
                                        text-align: right;
                                        vertical-align: top;
                                      "
                                    >
                                      {{
                                        kotasyonData.FaturaToplam.Satis
                                          | moneyformat
                                      }}
                                    </td>
                                    <td
                                      style="
                                        width: 10%;
                                        text-align: right;
                                        vertical-align: top;
                                      "
                                    >
                                      {{
                                        kotasyonData.FaturaToplam.Komisyon
                                          | moneyformat
                                      }}
                                    </td>
                                    <td
                                      style="
                                        width: 10%;
                                        text-align: right;
                                        vertical-align: top;
                                      "
                                    >
                                      {{
                                        kotasyonData.FaturaToplam.Iade
                                          | moneyformat
                                      }}
                                    </td>
                                    <td
                                      style="
                                        width: 10%;
                                        text-align: right;
                                        vertical-align: top;
                                      "
                                    >
                                      {{
                                        kotasyonData.FaturaToplam.SatisIade
                                          | moneyformat
                                      }}
                                    </td>
                                    <td
                                      style="
                                        width: 10%;
                                        text-align: right;
                                        vertical-align: top;
                                      "
                                    >
                                      {{
                                        kotasyonData.FaturaToplam.Kar | moneyformat
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>

                    <v-flex v-if="faturagoster == true" xs2 pa-2 sm2>
                      <v-card flat>
                        <v-layout row wrap>
                          <v-flex xs12 pa-3 sm12>
                            <v-layout row wrap>
                              <!--
                      <v-flex xs12 sm12>
                        <v-btn block v-if="faturagoster" :disabled="!faturagoster" @click="FaturaTaslakUpdate()"
                          color="info" outline>
                          <v-icon small>save</v-icon> Taslağı Kaydet
                        </v-btn>

                      </v-flex>
                      -->

                              <v-flex xs12 sm12>
                                <v-btn
                                  block
                                  v-if="faturagoster"
                                  :disabled="!faturagoster"
                                  @click="denemeyazdir('printJS-form')"
                                  color="info"
                                  outline
                                >
                                  <v-icon small>print</v-icon> {{ $t('Print') }}
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar
            :timeout="timeout"
            :top="y === 'top'"
            :bottom="y === 'bottom'"
            :right="x === 'right'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'"
            v-model="snackbar"
          >
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false"
              >{{$t('Close')}}</v-btn
            >
          </v-snackbar>

          <v-dialog
            v-model="dialogfiltre"
            scrollable
            persistent
            max-width="500px"
          >
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12> </v-flex>
                            <v-flex md12 xs12 sm12>
                              <cariaracomp
                                v-bind:etiket="$t('Currentcode_label')"
                                v-bind:value="Rapor.CariKod"
                                v-model="Rapor.CariKod"
                                :Coper="true"
                              ></cariaracomp>
                            </v-flex>

                            <v-flex md6 xs12 sm6>
                              <v-select
                                clearable
                                :items="itemssaticitip"
                                item-text="Aciklama"
                                item-value="Kod"
                                v-model="Rapor.SaticiTip"
                                :label="$t('Seller-Type')"
                                hide-details=""
                              >
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <genelarama
                                :autofocuss="true"
                                apiname="SaticiAra"
                                :tip="Rapor.SaticiKod"
                                :label="$t('Seller-Code')"
                                v-model="Rapor.PSaticiKod"
                              ></genelarama>
                            </v-flex>

                            <v-flex pl-1 xs12 sm12 md12>
                              <genelarama
                                apiname="MasrafMerkeziAra"
                                :label="$t('Expense-Center-v2')"
                                v-model="Rapor.MasrafMerkezi"
                              ></genelarama>
                              {{ Rapor.PMasrafMerkezi }}
                            </v-flex>
      

                            <v-flex xs12 sm12 md12>
                              <genelarama
                                apiname="SaticiAra"
                                :tip="12"
                                :label="$t('Tour-Operator')"
                                v-model="Rapor.OperatorKod"
                              >
                              </genelarama>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-checkbox
                                small
                                v-model="Rapor.FaturalamayaHazir"
                                :label="$t('Ready-for-Invoice')"
                                hide-details
                                color="green"
                              >
                              </v-checkbox>
                            </v-flex>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                  <yetkidialog ref="yetkidialog"></yetkidialog>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="filtreiptal()"
                  >{{ $t("cancel_button") }}</v-btn
                >
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()"
                  >{{ $t('Apply-Filters') }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
import auth from "../../../../../api/auth";
import tarihcomp from "../../../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../../../coper/tools";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import anatip from "@/components/app/coper/comp/anatip.vue";
import rez from "../../rezervasyon";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import draggable from "vuedraggable";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";
import takipno from '@/components/app/coper/component/takipno.vue'

export default {
  data() {
    return {
      UlkeID:1,
      Toplam0Gosterme:true,
      resarvationNoteView:true,
      dovizBirimi: "TL",
      kotasyonData: null,
      Kotasyon: {
        Tip: 1,
        Id: null,
        ParaBirimi: "TL",
        FaturaTurariKdvHaric: false,
        MusteriOdemelilerHaric: false,
        BirimFiyatOdaFiyati: false,
      },

      faturagoster: false,

      dizaynData2: [],
      dizaynData: [],
      itemssaticitip: rez.SaticiTip,
      itemsicdis: rez.IcDis,
      itemsopsiyon: rez.Opsiyon,
      itemstip: [
        {
          text: "PNR",
          value: 1,
        },
        {
          text: this.$t('Tracking-No'),
          value: 2,
        },
      ],

      itemskomisyon: [
        {
          text: this.$t('None'),
          value: false,
        },
        {
          text: this.$t('Available'),
          value: true,
        },
        {
          text: this.$t('All-v2'),
          value: null,
        },
      ],
      tarihTip: 0,

      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      filtrevarmi: false,
      search: "",
      searchsatilanbilet: null,
      searchiadebilet: null,
      searchvoid: null,

      headerssatis: [
        {
          text: "PNR",
          value: "PNR_No",
          width: "5%",
          align: "left",
        },
        {
          text: this.$t('Date'),
          value: "Kayit Tarihi",
          width: "5%",
          align: "left",
        },
        {
          text: this.$t("Currentcode_label"),
          value: "PNR_CariKod",
          width: "5%",
          align: "left",
        },
        {
          text: this.$t('Sales'),
          value: "SatisTutar",
          width: "5%",
          align: "left",
        },
        {
          text: this.$t('Buying'),
          value: "AlisTutar",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Commission'),
          value: "PKomisyonTutar",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Payment'),
          value: "Odeme",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Balance'),
          value: "Bakiye",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Commission'),
          value: "KomisyonTL",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Profit'),
          value: "PNR_Kar",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t("Title_label"),
          value: "CariUnvan",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Company-No'),
          value: "SirketNo",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Sales') + " TL",
          value: "PNR_SatisTL",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Buying') + " TL",
          value: "PNR_AlisTL",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Commission') + " TL",
          value: "PNR_KomisyonTL",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('First-Entry'),
          value: "Donem1",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Last-Departure'),
          value: "Donem2",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Profit')  + " TL",
          value: "PNR_KarTL",
          width: "10%",
          align: "left",
        },
        {
          text: "Satıcı Ad",
          value: "SaticiCariUnvan",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Booker'),
          value: "RezYapan",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Name'),
          value: "KisiIsimList",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Main-Type'),
          value: "AnaTip",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Agency'),
          value: "Acente",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t("Country_label"),
          value: "PNRUlke",
          width: "10%",
          align: "left",
        },
      ],

      Rapor: {
        SirketNo: null,
        PNR_No: null,
        Kayit_Tarihi1: null,
        Kayit_Tarihi2: null,
        Giris_Tarihi1: null,
        Giris_Tarihi2: null,
        Cikis_Tarihi1: null,
        Cikis_Tarihi2: null,
        SaticiTip: null,
        SaticiKod: null,
        CariKod: null,
        OperatorKod: null,
        MasrafMerkezi: null,
        FaturalamayaHazir: null,
        EFatura: null,
      },

      KayitTarihiBasla: null,
      KayitTarihiBitis: null,
      itemsairlinelist: [],
      hesapgurubu: [],
      masrafmerkezi: [],
      doviztipi: [],
      valid: true,
      tumsirketler: "",
      totalCount: 0,
      totalService: 0,
      totalAmount: 0,
      StartDate: null,
      EndDate: null,
      date: null,
      menu: false,
      modal: false,
      dateFormatted: "",
      date2: null,
      menu2: false,
      dateFormatted2: "",
      modal2: false,
      loading: false,
      items: [],
      load: false,
      load1: true,
      search3: "",

      renk1: "info",
      dialogfiltre: false,
      hesapkodu: [],
      kredikarti: [],
      statecari: [],
      searchcari: "",
      progress: false,
      tooltip: false,
      el: null,
      yok: false,
      itemssatis: [],
      itemsiade: [],
      itemsvoid: [],
      KdvHaric:false,
      Kur:null,
      butondurum: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      dictionary: {
        custom: {
          tarihsec: {
            required: () => this.$t('Please-select-a-date'),
          },
          tarihsec1: {
            required: () => this.$t('Please-select-a-date'),
          },
        },
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,
  mounted() {
    // this.$validator.localize("en", this.dictionary);
    // this.el = this.$refs.fab.$el;

    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      if (this.$route.query.islem == "get") {
        this.Kotasyon.Id = this.$route.query.PNR_No;
        this.getList();
      }
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      this.UlkeID=window.localStorage.getItem("UlkeID");
      var params = {
        CompanyCode: credentials.SirketKodu,
      };

      this.$http
        .post(auth.API_URL + "api/currency/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.doviztipi = response.body;

            this.applyDefaultCurrencyFromStorage();
        // <<< EKLE BİTİŞ
      }, (response) => {
        var tl = { DovizKod: "TL", DovizAdi: "TÜRK LİRASI", Title: "TL - TÜRK LİRASI" };
        this.doviztipi.push(tl);
        this.text1 = "Service Unavailable-Döviz";
        this.snackbar = true;

        // >>> HATA HALİNDE DE VARSAYILANI UYGULA
        this.applyDefaultCurrencyFromStorage();
        // <<< EKLE BİTİŞ
      

          },
          (response) => {
            var tl = {
              DovizKod: "TL",
              DovizAdi: "TÜRK LİRASI",
              Title: "TL - TÜRK LİRASI",
            };

            this.doviztipi.push(tl);

            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            }
          }
        );
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var url = "#/";
              window.open(url, "_self");
            }
          } else {
          }
        });
    }
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    currencyformat: function (t) {
      return helpers.currencyformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
    gelenfat: function (m) {
      if (m.Tip == 1) {
        return helpers.moneyformat(m.Tutar);
      } else {
        return null;
      }
    },
    satisfat: function (m) {
      if (m.Tip == 2) {
        return helpers.moneyformat(m.Tutar);
      } else {
        return null;
      }
    },
    komfat: function (m) {
      if (m.Tip == 3) {
        return helpers.moneyformat(m.Tutar);
      } else {
        return null;
      }
    },
    iafat: function (m) {
      if (m.Tip == 4) {
        return helpers.moneyformat(m.Tutar);
      } else {
        return null;
      }
    },
    satisiafat: function (m) {
      if (m.Tip == 5) {
        return helpers.moneyformat(m.Tutar);
      } else {
        return null;
      }
    },
  },

  components: {
    tarihcomp: tarihcomp,
    yetkidialog,
    hatadialog,
    anatip,
    genelarama,
    referansmerkezicomp,
    pnrbul,
    draggable,
    cariaracomp,
    takipno
  },
  watch: {
    "Kotasyon.Tip": function (val) {
      this.Kotasyon.Id = null;
    },
  },
  methods: {
 applyDefaultCurrencyFromStorage() {
    try {
      // Öncelik "response" anahtarında (ekranda gördüğün JSON)
      const rawResp = window.localStorage.getItem("response");
      let defaultCur = null;

      if (rawResp) {
        const parsed = JSON.parse(rawResp);
        if (parsed && parsed.ParaBirimi) defaultCur = parsed.ParaBirimi;
      }

      // Bulunamazsa "credentials" içinden dene
      if (!defaultCur) {
        const creds = window.localStorage.getItem("credentials");
        if (creds) {
          const c = JSON.parse(creds);
          // c.UserInfo?.ParaBirimi ya da doğrudan c.ParaBirimi olabilir
          defaultCur = (c && (c.ParaBirimi || (c.UserInfo && c.UserInfo.ParaBirimi))) || null;
        }
      }

      if (defaultCur) {
        // Döviz listende var mı kontrol et (item-value = DovizKod)
        const exists = this.doviztipi.some(d => d.DovizKod === defaultCur);
        if (exists) {
          this.Kotasyon.ParaBirimi = defaultCur;
          this.dovizBirimi = defaultCur;
          this.Kur = defaultCur;
        }
      }
    } catch (e) {
      // sessiz geç
    }
  },

    getDovizAdi() {
      return helpers.getDovizAdi(this.dovizBirimi);
    },
    getDateNow() {
      return helpers.getDateNow();
    },
    denemeyazdir(divName) {
      var mywindow = window.open("", "PRINT", "height=500,width=700");

      mywindow.document.write("</head>");
      mywindow.document.write("<style>");
      //yazdırılmayacak alanlar için css ekliyorum
      mywindow.document.write(
        "@media print{.no-print {display:none !important;}}"
      );
      mywindow.document.write(
        "table{font-size:9px;border-collapse: collapse;}"
      );
      mywindow.document.write("</style>");
      mywindow.document.write("<body >");
      mywindow.document.write(document.getElementById(divName).innerHTML);
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      mywindow.close();

      return true;
    },
    faturala() {
      var degerler = [];

      this.dizaynData2.forEach((element) => {});

      this.dizaynData2.forEach((element) => {
        degerler.push(element.IslemRef);
      });

      window.localStorage.setItem("container", JSON.stringify(degerler));
      var url = "#/coper/komisyonfaturasi/faturaislem";
      window.open(url, "_target");
    },
    ItemAktar(kaynak, hedef, item) {
      var n = kaynak.indexOf(item);
      hedef.push(item);
      kaynak.splice(n, 1);
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    HataYonetimi(response, request, baslik) {
      if (response.status === 500) {
        //Internal Server Error
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable -" + baslik;
        this.snackbar = true;
      }
    },

    git(val) {
      var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;
      window.open(url, "_target");
    },
    getList: getList,
    filtrele: filtrele,
    filtrekayit: filtrekayit,
    filtreiptal: filtreiptal,
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
  },
};

function filtrele() {
  this.dialogfiltre = true;
}

function filtrekayit() {
  this.filtrevarmi = true;
  this.dialogfiltre = false;
  this.getList();
}

function filtreiptal() {
  this.filtrevarmi = false;
  this.dialogfiltre = false;

  this.Rapor.PPNR_No = null;
  this.Rapor.PPNR_ParaBirimi = "TL";
  this.Rapor.PCariKod = null;
  this.Rapor.PSaticiTip = null;
  this.Rapor.PSaticiKod = null;
  this.Rapor.PDosyaTip = null;
  this.Rapor.PDosya = null;
  this.Rapor.PAcente = null;
  this.Rapor.PPNRBir = null;
  this.Rapor.PCariHesapGrubu = null;
  this.Rapor.PCariTip = null;
  this.Rapor.PSaticiGrup = null;
  this.Rapor.PSaticiIc_Dis = null;
  this.Rapor.PTurOp = null;
  this.Rapor.PFaturali = null;
  this.Rapor.POpsiyon = null;
  this.Rapor.PAnaTip = null;
  this.Rapor.PCariAnaHesap = null;
  this.Rapor.PIptalRaporu = null;
  this.Rapor.PRezGrupID = null;
  this.Rapor.PSatisGrubu = null;
  this.Rapor.PSatisGrupTip = null;
  this.Rapor.PSaticiOdemesiHesapla = null;
  this.Rapor.PMasrafMerkezi = null;
  this.Rapor.PAcenteDepartmanID = null;
  this.Rapor.PPozisyonNo = null;
  this.Rapor.PSatisFaturaNo = null;
  this.Rapor.PMusteriOdemelilerHaric = null;
  this.Rapor.PReferans = null;
  this.Rapor.PSatisTip1 = null;
  this.Rapor.PSatisTip2 = null;
  this.Rapor.PSatisTip3 = null;
  this.Rapor.PSatisTip4 = null;
  this.Rapor.PProfilSablonId = null;
  this.Rapor.PKomisyonFaturali = null;
  this.Rapor.PGelenFaturali = null;
}

function getList() {
  this.progress = true;
  this.load1 = false;
  this.KdvHaric = this.Kotasyon.FaturaTurariKdvHaric;
  this.Kur = this.Kotasyon.ParaBirimi;
  if(this.$route.query.islem == "get"){
      this.Kotasyon.Tip = this.$route.query.Tip;
  }
  let params = this.Kotasyon;

  tool.http_post(this, "KotasyonFormu", params).then(
    (response) => {
      this.progress = false;
      this.load1 = true;
      if (response.body.Status == true) {
        this.faturagoster = true;
        this.kotasyonData = response.body.data;

        this.dovizBirimi = this.Kotasyon.ParaBirimi;
      } else {
        this.text1 = response.body.ErrorList[0];
        this.snackbar = true;
        this.faturagoster = false;
      }
    },

    (response) => {
      this.progress = false;
      this.load1 = true;
     this.text1 = $t('Error-Occured-Please-Try-Again')
      this.snackbar = true;
      this.faturagoster = false;
    }
  );
  if (this.$refs.formgunluksatis.validate()) {
  }
}

function beforeMount() {}
</script>
<style>
.project.complete {
  border-left: 4px solid green;
}

.project.ongoing {
  border-left: 4px solid orange;
}

.project.overdue {
  border-left: 4px solid red;
}
</style>